import type { StandardsDraft } from "../standardsModel";

/** What every Brand Configuration card gets from the page. */
export type SectionProps = {
  draft: StandardsDraft;
  patch: (partial: Partial<StandardsDraft>) => void;
  /** `edit_standards`: without it every field and switch is read-only. */
  canEdit: boolean;
  /** The override switches; hidden for a firm of one, whose decks are its own (§6.2). */
  showAllowToggles: boolean;
};

/** A switch's label, as the frames phrase it. */
export const allowLabel = (what: string) => `Allow team members to overwrite ${what} settings inside the PowerPoint add-in?`;
